<div [ngClass]="isLauncher ? 'app-container-result' : 'app-container'" [class.selected]="selected">
  @if (model.linkIndicator && isLauncher) {
    <link-indicator [name]="model.link?.name" [color]="model.link?.color" class="link-indicator"></link-indicator>
  }
  <div class="icon-container">
    <u-icon [model]="{ type: 'img', value: model?.view?.icon }" [styles]="getIconStyles()"></u-icon>
  </div>
  <div class="main-container">
    <div class="main-container-details">
      <result-title
        [model]="model.view.title"
        [highlights]="model.highlights"
        [selected]="selected"
        click-invoker
        (invoke)="
          onInvoke({
            command: $event.command,
            context: makeContext({ appId: model?.resource?.appId }, $event.context),
            trigger: $event.trigger,
            source: $event.source,
            immediate: $event.immediate,
          })
        "
      ></result-title>
      <result-snippet [model]="model.view.snippet" class="result-snippet"></result-snippet>
    </div>
    <div class="square-button-container">
      <square-button
        [active]="contextMenuHelper?.source === 'actions'"
        click-invoker
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        #actions
        >•••</square-button
      >
    </div>
  </div>
</div>
